import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex row no-wrap" }

import { computed, PropType} from "vue";
  
  import { LoanStatusType_Enum } from "src/types/enums/index";
  import { LoanApplication } from "src/types/loan-application/index";
  import QuickQuote from "src/types/quote/quick-quote";
  import DragPane from "./DragPane.vue";
  import PipelineColumn from "src/components/customer/views/PipelineColumn.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PipelineView',
  props: {
    applications: {
      type: Array as PropType<LoanApplication[]>,
      default: []
    },
    quickQuotes: {
      type: Array as PropType<LoanApplication[]>,
      default: []
    },
    searching: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingQQ: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const props = __props

  const defaultCollapsed = ['Not Taken Up', 'Unable To Contact', 'Completed']
  const stages = computed(() => {
    if (!props.applications) {
      return [{ name: "Quick Quote", apps: props.quickQuotes, collapsed: false }]
    }
    const allStates = [] as { name: string, apps: LoanApplication[], collapsed: boolean }[];
    const ntu = [] as LoanApplication[];
    const keys = Object.keys(LoanStatusType_Enum).filter(k => isNaN(Number(k)) && k !== "Quick Quote")
    const values = Object.values(LoanStatusType_Enum).filter(k => !isNaN(Number(k)) && k !== -1);
    keys.forEach((s, i) => {
      // All apps by the state
      const ps = props.applications.filter(a => a.state === values[i]);
      // Group all ntu into one column
      s.includes("NTU") ? ntu.push(...ps) : allStates.push({ name: s, apps: ps, collapsed: defaultCollapsed.find(a => a === s) ? true : false })
    })
    return [{ name: "Quick Quote", apps: props.quickQuotes, collapsed: false }, ...allStates, { name: "Not Taken Up", apps: ntu && ntu.length > 0 ? ntu.sort((a, b) => new Date(a.lastUpdated).getTime() < new Date(b.lastUpdated).getTime() ? 1 : -1) : [], collapsed: true }];
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DragPane, {
    horizontal: "",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stages.value, (stage) => {
          return (_openBlock(), _createBlock(PipelineColumn, {
            key: stage.name+stage.apps.length,
            name: stage.name,
            applications: stage.apps,
            isLoading: stage.name == 'Quick Quote' ? __props.isLoadingQQ : __props.isLoading,
            collapsed: (stage.apps.length === 0) 
          }, null, 8, ["name", "applications", "isLoading", "collapsed"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})